export const VieMessageConstant = {
  LoginSuccessfully: 'Đăng nhập thành công.',

  ResetPasswordSuccessfully: 'Đặt lại mật khẩu thành công.',

  UpdateAccountSuccessfully: 'Cập nhật tài khoản thành công.',

  SentEmailConfirmationSuccessfully: 'Đã email gửi xác nhận thành công.',
  ConfirmedOTPCodeSuccessfully: 'Xác nhận mã OTP thành công.',

  CreatedNewKitchenCenterSuccessfully: 'Tạo bếp trung tâm mới thành công.',
  UpdatedKitchenCenterSuccessfully: 'Cập nhật thông tin bếp trung tâm thành công.',
  UpdatedKitchenCenterStatusSuccessfully: 'Cập nhật trạng thái bếp trung tâm thành công.',
  DeletedKitchenCenterSuccessfully: 'Đã xóa bếp trung tâm thành công.',

  CreatedNewBrandSuccessfully: 'Tạo mới thương hiệu thành công.',
  UpdatedBrandSuccessfully: 'Cập nhật thương hiệu thành công.',
  UpdatedBrandStatusSuccessfully: 'Cập nhật trạng thái thương hiệu thành công.',
  UpdatedBrandProfileSuccessfully: 'Cập nhật hồ sơ thương hiệu thành công.',
  DeletedBrandSuccessfully: 'Đã xóa thương hiệu thành công.',

  UpdatedStoreStatusSuccessfully: 'Đã cập nhật trạng thái cửa hàng thành công.',
  UpdatedStoreInformationSuccessfully: 'Cập nhật thông tin cửa hàng thành công.',
  DeletedStoreSuccessfully: 'Đã xóa cửa hàng thành công.',
  RegisteredNewStoreSuccessfully: 'Đăng ký cửa hàng mới thành công.',
  ConfirmedStoreRegistrationSuccessfully: 'Xác nhận đăng ký cửa hàng thành công.',

  CreatedNewCategorySuccessfully: 'Đã tạo danh mục mới thành công.',
  UpdatedCategorySuccessfully: 'Đã cập nhật danh mục thành công.',
  DeletedCategorySuccessfully: 'Đã xóa danh mục thành công.',
  CreatedExtraCategoriesToNormalCategorySuccessfully: 'Tạo thành công các danh mục extra cho danh mục thường.',

  CreatedNewBankingAccountSuccessfully: 'Tạo mới tài khoản ngân hàng thành công.',
  DeletedBankingAccountSuccessfully: 'Xóa tài khoản ngân hàng thành công.',
  UpdatedStatusBankingAccountSuccessfully: 'Cập nhật trạng thái tài khoản ngân hàng thành công.',
  UpdatedBankingAccountSuccessfully: 'Cập nhật thông tin tài khoản ngân hàng thành công.',

  CreatedNewProductSuccessfully: 'Tạo mới sản phẩm thành công.',
  UpdatedProductSuccessfully: 'Cập nhật sản phẩm thành công.',
  UpdatedProductStatusSuccessfully: 'Cập nhật trạng thái sản phẩm thành công.',
  DeletedProductSuccessfully: 'Đã xóa sản phẩm thành công.',

  CreatedPartnerSuccessfully: 'Tạo mới đối tác thành công.',
  UpdatedPartnerSuccessfully: 'Cập nhật thông tin đối tác thành công.',
  UpdatedPartnerStatusSuccessfully: 'Đã cập nhật trạng thái đối tác thành công.',
  DeletedPartnerSuccessfully: 'Đã xóa đối tác thành công.',

  CreatedNewStorePartnerSuccessfully: 'Tạo mới đối tác cửa hàng thành công.',
  DeletedStorePartnerSuccessfully: 'Đã xóa đối tác cửa hàng thành công.',
  UpdatedStatusStorePartnerSuccessfully: 'Đã cập nhật trạng thái đối tác cửa hàng thành công.',
  UpdatedStorePartnerSuccessfully: 'Cập nhật thông tin đối tác cửa hàng thành công.',
  UpdatedStorePartnerStatusSuccessfully: 'Cập nhật thông tin trạng thái đối tác cửa hàng thành công.',

  CreatedCashierSuccessfully: 'Tạo mới nhân viên thu ngân thành công.',
  UpdatedCashierSuccessfully: 'Cập nhật nhân viên thu ngân thành công.',
  UpdatedCashierStatusSuccessfully: 'Cập nhật trạng thái nhân viên thu ngân thành công.',
  DeletedCashierSuccessfully: 'Đã xóa nhân viên thu ngân thành công.',
  UpdatedCashierProfileSuccessfully: 'Cập nhật hồ sơ nhân viên thu ngân thành công.',

  CreatedPartnerProductSuccessfully: 'Đã tạo thành công sản phẩm đối tác mới.',
  UpdatedPartnerProductSuccessfully: 'Cập nhật sản phẩm đối tác thành công.',
  DeletedPartnerProductSuccessfully: 'Đã xóa sản phẩm đối tác thành công.',
  UpdatedPartnerProductStatusSuccessfully: 'Đã cập nhật trạng thái sản phẩm của đối tác thành công.',

  UpdateOrderSuccessfully: 'Cập nhật đơn hàng thành công.',

  UpdatedConfigurationsSuccessfully: 'Đã cập nhật cấu hình hệ thống thành công.',

  MoneyExchangeToKitchenCenterSuccessfully: 'Đã gửi tiền tới bếp trung tâm thành công.',
  WithdrawMoneySuccessfully: 'Rút tiền cho cửa hàng thành công.',
  UpdateSchedulingTimeJob: 'Đã thay đổi thời gian tự động chuyển tiền thành công.',
};
